const Login = () => System.import('../App/View/Login.vue');
const Notificacao = () => System.import('../App/View/Notificacao.vue');
const Mudarsenha = () => System.import('../App/View/Mudarsenha.vue');
const Layout = () => System.import('../../Shared/Layout/App/View/Layout.vue');

export const UsuarioRoutes = [
  {path: '', name: 'login', component: Login},
  // {path: 'mudarsenha', name: 'mudarsenha', component: Mudarsenha,  meta: {auth: true}},
  {path: '/',
    component: Layout,
    children: [
      {path: 'mudarsenha', name: 'mudarsenha', component: Mudarsenha,  meta: {auth: true}},
    ]},
  {
    path: '/',
    component: Layout,
    children: [
      {path: 'notificacao', name: 'notificacao', component: Notificacao, meta: {auth: true}},
      {path: 'notificacao/:id', name: 'dados-notificacao', component: Notificacao, meta: {auth: true}},

    ]
  },

];




// WEBPACK FOOTER //
// ./src/components/Usuario/Rotas/Routes.js